import React from 'react'
import Gallery from './Gallery'

const GalleryPage = () => {
  return (
    <div style={{ paddingTop : '10vw'}}><Gallery/></div>
  )
}

export default GalleryPage